import styled from "styled-components";
import { COLORS, responsive } from "../../../../../../styles/constants.style";

export const InheritDocumentsSearchFormWrapper = styled.div`
  background-color: ${COLORS.cirrus_white};

  .form-container {
    padding: 0px 0px 16px 16px;

    ${responsive.MOBILE`
      padding: 0px 8px 16px 8px;
    `}

    .first-row {
      padding-top: 24px;
    }
  }

  .button-container {
    justify-content: end;
    padding-bottom: 20px;
    gap: 16px;
    margin-right: 16px;
    margin-top: 40px;
    ${responsive.MOBILE`
      flex-direction:column-reverse;
      padding: 16px 8px 16px 8px !important;
      padding-bottom: 0px !important;
      margin-top: 0px !important;
      margin-right: 0px !important;
      padding-bottom: 16px !important;
    `}
  }

  .MuiGrid2-root {
    padding-right: 16px;

    ${responsive.MOBILE`
       padding-right: 8px;
    `}
  }
  .MuiGrid2-container {
    padding-right: 0px;
  }
`;
